<template>
    
    <span>
        <Badge :type="type" v-if="commande.commandeStatut" v-html="commande.commandeStatut && commande.commandeStatut.status" />
        <Badge type="info" v-if="commande.commandeStatut && commande.commandeStatut.facturationStatus">{{ commande.commandeStatut.facturationStatus }}</Badge>
        <Badge type="warning" v-if="!commande.isPaid" >Non payée</Badge>      
    </span>

</template>

<script>

import Badge from '@/components/badge/Badge.vue'

export default {

    components: {
        Badge
    },

    props: {
        commande: Object
    },

    computed: {

        type: function() {

            switch ( this.commande.commandeStatut?.level )
            {
                case 'info':
                    return 'info'

                case 'success':
                    return 'success'

                case 'notice':
                    return 'notice'

                case 'warning':
                    return 'warning'

                case 'danger':
                    return 'danger'
            }

            return 'secondary';
        }
    }
}
</script>


